import { DOCK_LABELS } from "../../shared/constants/pageAgentLabels";
import type { ClearChatConfirmControls } from "../hooks/useClearChatConfirm";

interface ClearChatConfirmProps {
  controls: ClearChatConfirmControls;
  /** True while the clear is on its way to the server: both buttons wait for it. */
  clearing: boolean;
  /** False when a run started meanwhile: Clear waits, Cancel still works. */
  enabled: boolean;
}

/** "Clear this conversation?" with Clear and Cancel, inline under the header. */
export function ClearChatConfirm({ controls, clearing, enabled }: ClearChatConfirmProps) {
  if (!controls.confirming) return null;
  const messageId = `${controls.promptId}-message`;
  return (
    <div id={controls.promptId} className="pa-confirm" role="alertdialog" aria-modal="false"
      aria-label={DOCK_LABELS.clearChat} aria-describedby={messageId} onKeyDown={controls.onPromptKeyDown}>
      <p id={messageId} className="pa-confirm-message">{DOCK_LABELS.clearConfirm}</p>
      <div className="pa-confirm-actions">
        <button ref={controls.cancelRef} type="button" className="pa-button pa-button-secondary" disabled={clearing} onClick={controls.cancel}>
          {DOCK_LABELS.clearCancel}
        </button>
        <button type="button" className="pa-button" disabled={clearing || !enabled} onClick={() => void controls.confirm()}>
          {clearing ? DOCK_LABELS.clearing : DOCK_LABELS.clearConfirmAction}
        </button>
      </div>
    </div>
  );
}
